import { useEffect, useRef } from "react";

/**
 * @param {(buttonIndex: number) => void} callback
 */
export function useGamepad(callback) {
  const lastButtons = useRef(/** @type {Array<boolean>} */ ([]));
  const animationRef = useRef(/** @type {?number} */ (null));

  useEffect(() => {
    const loop = () => {
      const gamePad = navigator.getGamepads()[0];

      if (gamePad) {
        if (lastButtons.current.length !== gamePad.buttons.length) {
          lastButtons.current = gamePad.buttons.map(() => false);
        }

        gamePad.buttons.forEach((btn, index) => {
          const pressed = btn.pressed;
          const prev = lastButtons.current[index];

          if (pressed && !prev) {
            console.log("Bouton pressé :", index);
            callback(index);
          }

          lastButtons.current[index] = pressed;
        });
      }

      animationRef.current = requestAnimationFrame(loop);
    };

    loop();

    return () => cancelAnimationFrame(/** @type {number} */ (animationRef.current));
  }, [callback]);
}
